module.exports = __webpack_public_path__ + "static/media/gift-goods.bdb603e2.png";